module.exports = __webpack_public_path__ + "img/Xgrow-2-pt.cb36af8d.png";